import AssetService from "@/services/AssetService";
const { asset, imgUrl, iconUrl, avatarUrl, pictureUrl } = AssetService;
export default {
  methods: {
    getMap(mapName, noAutoLoad = false) {
      return this.$store.getters.getMap(mapName, noAutoLoad);
    },
    getArray(mapName, noAutoLoad = false) {
      return this.$store.getters.getArray(mapName, noAutoLoad);
    },
    getObject(value, mapName, property = "id") {
      if (!value && value != 0) {
        return null;
      }
      return this.$store.getters.getObject(value, mapName, property);
    },
    isObjectEmpty(obj) {
      if (!obj) return;
      return Object.keys(obj).length === 0 && obj.constructor === Object;
    },
    roundNumber(value, step = 1.0, type = "round") {
      step || (step = 1.0);
      const inv = 1.0 / step;
      const mathFunc =
        "ceil" === type
          ? Math.ceil
          : "floor" === type
          ? Math.floor
          : Math.round;

      return mathFunc(value * inv) / inv;
    },
    asset,
    imgUrl,
    iconUrl,
    avatarUrl,
    pictureUrl,
  },
};
